import React from 'react'

const Advisor3 = () => {
  return (
<section className="w-full">
  {/* Full Background Image Section */}
  <div
    className="w-full h-[850px] bg-cover "
    style={{
      backgroundImage:
        "url('https://res.cloudinary.com/dzngpgki4/image/upload/v1744993769/Rectangle_34637465_a8iquc.png')",
    }}
  ></div>

  {/* Box below the image */}
  <div
    className="w-full h-[223px] bg-[#152C24] rounded-b-[5px] md:px-20 md:pt-5 md:pb-5" 
  >
    <h1 className='text-white font-medium md:text-[48px]'>
    Farmers Networks
    </h1>
    <h1 className='text-white font-extrabold md:text-[64px] md:mt-1'>
    Advisor
    </h1>
  </div>

  {/* Paragraph Section */}
  <div className="w-full bg-[#2E453D] px-6 md:px-20 py-16">
  <div className="text-white text-[32px] md:text-[48px] font-[500] leading-relaxed font-['Inter'] whitespace-pre-line">
  <div className="text-white text-[32px] md:text-[48px] font-[500] leading-relaxed font-['Inter'] whitespace-pre-line">

  <p className="md:mb-10 mb-5">
  Biography 
  </p>

 

</div>

  <div className='md:mt-40 mt-10'></div>
</div>

  </div>
</section>

  )
}

export default Advisor3